import { defineComponent as _defineComponent } from 'vue'
import EmptyContent from "@/components/shared/EmptyContent.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { useServiceStore } from "@/stores/serviceStore";
import { computed } from "vue";


const __default__ = {
  name: "LostFoundGuide",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["onClickClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const serviceStore = useServiceStore();

const lostAndFoundGuideUrl = computed(
  () => serviceStore.serviceInfo?.lostAndFoundGuideUrl ?? ""
);

const emitOnClickClose = () => {
  emit("onClickClose");
};

const __returned__ = { emit, serviceStore, lostAndFoundGuideUrl, emitOnClickClose, EmptyContent, NavigationBar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})